import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import User from "@/models/User";
import AdminAdapter from "@/adapters/admin";

const adminAdapter = new AdminAdapter();

@Module
export default class AdminStore extends VuexModule {

    userList: User[] = [];
    userListLoading: boolean = false;

    @Mutation
    setUserList(list: User[]) {
        this.userList = list;
    }

    @Mutation
    setUserListLoading(state: boolean) {
        this.userListLoading = state;
    }

    @Mutation
    addUserToList(u: User) {
        this.userList.push(u);
    }

    @Mutation
    deleteUserFromList(u: User) {
        const idx: number = this.userList.findIndex((user: User) => {
            return user.id === u.id;
        });
        this.userList.splice(idx, 1);
    }

    @Action({ rawError: true })
    async fetchUserList() {
        try {
            this.context.commit('setUserListLoading', true);
            const users: User[] = await adminAdapter.getUsersList();
            this.context.commit('setUserList', users);
        } catch (e) {
            throw e;
        } finally {
            this.context.commit('setUserListLoading', false);
        }
    }

    @Action({ rawError: true })
    async createUserInvitation(u: User): Promise<User | null> {
        try {
            this.context.commit('setUserListLoading', true);
            const user: User = await adminAdapter.createUser(u);
            this.context.commit('addUserToList', user);
            return user;
        } catch (e) {
            throw e;
        } finally {
            this.context.commit('setUserListLoading', false);
        }
    }

    @Action({ rawError: true })
    async deleteUser(u: User): Promise<void> {
        await adminAdapter.deleteUser(u);
        this.context.commit('deleteUserFromList', u);
    }

}
